import { api } from "#/lib/api-client";
import type {
  PageResponse,
  UserDepartmentOption,
  UserRow,
  UsersFilterParams,
} from "./types";

function buildParams(params: UsersFilterParams = {}) {
  return {
    page: params.page ?? 0,
    size: params.size ?? 10,
    q: params.search?.trim() || undefined,
    enabled: params.enabled === "" ? undefined : params.enabled,
    locked: params.locked === "" ? undefined : params.locked,
    departmentCode: params.departmentCode || undefined,
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalizePage<T>(raw: any): PageResponse<T> {
  const body = raw?.content !== undefined ? raw : (raw?.data ?? raw);
  const meta = body?.page ?? body;
  return {
    content:       body?.content       ?? [],
    totalElements: meta?.totalElements ?? meta?.total_elements ?? meta?.total ?? 0,
    totalPages:    meta?.totalPages    ?? meta?.total_pages    ?? 0,
    number:        meta?.number        ?? 0,
    size:          meta?.size          ?? 0,
    first:         meta?.number === 0,
    last:          (meta?.number ?? 0) + 1 >= (meta?.totalPages ?? meta?.total_pages ?? 1),
  };
}

export async function fetchUsers(params: UsersFilterParams = {}) {
  const { data } = await api.get("/api/hr/users", { params: buildParams(params) });
  return normalizePage<UserRow>(data);
}

export async function fetchUserById(id: number) {
  const { data } = await api.get<UserRow>(`/api/hr/users/${id}`);
  return data;
}

export async function fetchDepartmentOptions() {
  const { data } = await api.get<UserDepartmentOption[]>(
    "/api/hr/departments/options",
  );

  return data;
}
